export const EMI_REPAYMENT_CALCULATOR_CONFIG = {
  KEY_NAME: 'repayment_calculator',
};

export const EMI_REPAYMENT_METHODS = {
  EMI: 'EMI',
  EPP: 'EPP',
  STPL: 'STPL',
  GOLD: 'GOLD',
  BULLET: 'BULLET',
  BALLOON: 'BALLOON',
};

export const EMI_REPAYMENT_INTERVALS = {
  WEEKLY: 'WEEKLY',
  FORTNIGHTLY: 'FORTNIGHTLY',
  MONTHLY: 'MONTHLY',
  AT_MATURITY: 'AT_MATURITY',
};

export const EMI_REPAYMENT_INTERVAL_OPTIONS = [
  { label: 'Weekly', value: EMI_REPAYMENT_INTERVALS.WEEKLY },
  { label: 'Fortnightly', value: EMI_REPAYMENT_INTERVALS.FORTNIGHTLY },
  { label: 'Monthly', value: EMI_REPAYMENT_INTERVALS.MONTHLY },
];

export const EMI_STPL_REPAYMENT_INTERVAL_OPTIONS = [
  { label: 'At Maturity', value: EMI_REPAYMENT_INTERVALS.AT_MATURITY },
  { label: 'Monthly', value: EMI_REPAYMENT_INTERVALS.MONTHLY },
];

export const EMI_INSTALMENT_UNIT_LABEL = {
  [EMI_REPAYMENT_INTERVALS.WEEKLY]: 'weeks',
  [EMI_REPAYMENT_INTERVALS.FORTNIGHTLY]: 'fortnights',
  [EMI_REPAYMENT_INTERVALS.MONTHLY]: 'months',
  [EMI_REPAYMENT_INTERVALS.AT_MATURITY]: 'instalment',
};

export const EMI_PERIODS_PER_YEAR = {
  [EMI_REPAYMENT_INTERVALS.WEEKLY]: 52,
  [EMI_REPAYMENT_INTERVALS.FORTNIGHTLY]: 26,
  [EMI_REPAYMENT_INTERVALS.MONTHLY]: 12,
  [EMI_REPAYMENT_INTERVALS.AT_MATURITY]: 1,
};

export const EMI_INSTALMENT_LIMITS = {
  [EMI_REPAYMENT_INTERVALS.WEEKLY]: { min: 1, max: 260 },
  [EMI_REPAYMENT_INTERVALS.FORTNIGHTLY]: { min: 1, max: 130 },
  [EMI_REPAYMENT_INTERVALS.MONTHLY]: { min: 1, max: 360 },
  [EMI_REPAYMENT_INTERVALS.AT_MATURITY]: { min: 1, max: 1 },
};

export const EMI_LOAN_AMOUNT_LIMITS = { min: 1000, max: 10000000, step: 1000 };
export const EMI_INTEREST_LIMITS = { min: 0, max: 60, step: 0.25 };
export const EMI_BALLOON_PRINCIPAL_LIMITS = { min: 0, step: 1000 };

export const EMI_CALCULATOR_DEFAULTS = {
  loan_amount: 20000,
  interest: 24,
  repayment_interval: EMI_REPAYMENT_INTERVALS.WEEKLY,
  instalments: 52,
  balloon_principal: 5000,
};

export const EMI_CALCULATOR_UI_DEFAULT = {
  intervalOptions: EMI_REPAYMENT_INTERVAL_OPTIONS,
  fields: {
    repayment_interval: true,
    emi_start_date: true,
    maturity_date: false,
    loan_amount: true,
    balloon_principal: false,
    interest: true,
    instalments: true,
  },
  defaults: {
    repayment_interval: EMI_REPAYMENT_INTERVALS.WEEKLY,
    instalments: 52,
  },
  labels: {
    emi_start_date: 'First EPI date',
    maturity_date: 'Maturity date',
    balloon_principal: 'Balloon principal',
  },
};

export const EMI_CALCULATOR_UI_AT_MATURITY = {
  intervalOptions: EMI_STPL_REPAYMENT_INTERVAL_OPTIONS,
  fields: {
    ...EMI_CALCULATOR_UI_DEFAULT.fields,
    maturity_date: true,
  },
  hideInstalmentsOnAtMaturity: true,
  defaults: {
    repayment_interval: EMI_REPAYMENT_INTERVALS.AT_MATURITY,
    instalments: 1,
  },
  labels: {
    ...EMI_CALCULATOR_UI_DEFAULT.labels,
  },
};

export const EMI_CALCULATOR_UI_GOLD = {
  ...EMI_CALCULATOR_UI_AT_MATURITY,
  hideInstalmentsOnAtMaturity: false,
  defaults: {
    repayment_interval: EMI_REPAYMENT_INTERVALS.AT_MATURITY,
    instalments: 12,
  },
};

export const EMI_CALCULATOR_UI_BALLOON = {
  ...EMI_CALCULATOR_UI_DEFAULT,
  fields: {
    ...EMI_CALCULATOR_UI_DEFAULT.fields,
    balloon_principal: true,
  },
  defaults: {
    ...EMI_CALCULATOR_UI_DEFAULT.defaults,
    balloon_principal: EMI_CALCULATOR_DEFAULTS.balloon_principal,
  },
};

export const EMI_CALCULATOR_UI_BY_METHOD = {
  [EMI_REPAYMENT_METHODS.EMI]: EMI_CALCULATOR_UI_DEFAULT,
  [EMI_REPAYMENT_METHODS.EPP]: EMI_CALCULATOR_UI_DEFAULT,
  [EMI_REPAYMENT_METHODS.STPL]: EMI_CALCULATOR_UI_AT_MATURITY,
  [EMI_REPAYMENT_METHODS.GOLD]: EMI_CALCULATOR_UI_GOLD,
  [EMI_REPAYMENT_METHODS.BULLET]: EMI_CALCULATOR_UI_AT_MATURITY,
  [EMI_REPAYMENT_METHODS.BALLOON]: EMI_CALCULATOR_UI_BALLOON,
};

export const EMI_CHART_COLORS = {
  principal: '#0c4e8d',
  interest: '#f59e0b',
  balance: '#10b981',
};

export const EMI_SCHEDULE_PAGE_SIZE = 12;

export const EMI_SHOW_BREAKDOWN_CHART = false;

export const EMI_START_DATE_API_FORMAT = 'YYYY-MM-DD';
